import React from 'react';
import classnames from 'classnames';
import { Text } from "../../../../../../Typography";
import styles from './TextItem.scss';

var TextItem = function TextItem(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Text, {
    className: classnames(styles.item, className)
  }, children);
};

export default TextItem;